import React, { Component } from "react";
import { ErrorCode } from "../../../const";
import { v4 as uuidv4 } from "uuid";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
  Table,
  ControlLabel,
  Modal,
  ModalHeader,
  ModalBody,
} from "react-bootstrap";
import UpdateNameAndReportDateModalModal from "../../../components/UpdateNameAndReportDate";
import { isInvalid } from "redux-form";

// Convert JSON string to array directly (no need for JSON.parse)
const HARD_FILE_INPUTS = [
  {
    name: "STG_ACCOUNT_MITIGANT_MAP.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_ACCOUNT_MITIGANT_MAP.csv",
  },
  {
    name: "STG_BANK_POSITIONS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_BANK_POSITIONS.csv",
  },
  {
    name: "STG_CARDS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_CARDS.csv",
  },
  {
    name: "STG_FOREX_EXPOSURES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_FOREX_EXPOSURES.csv",
  },
  {
    name: "STG_FUTURES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_FUTURES.csv",
  },
  {
    name: "STG_GUARANTEES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_GUARANTEES.csv",
  },
  {
    name: "STG_INSTRUMENT_CONTRACT_MASTER.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_INSTRUMENT_CONTRACT_MASTER.csv",
  },
  {
    name: "STG_INVESTMENTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_INVESTMENTS.csv",
  },
  {
    name: "STG_LETTER_CREDIT.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_LETTER_CREDIT.csv",
  },
  {
    name: "STG_LOAN_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_LOAN_CONTRACTS.csv",
  },
  {
    name: "STG_MITIGANT.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_MITIGANT.csv",
  },
  {
    name: "STG_MM_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_MM_CONTRACTS.csv",
  },
  {
    name: "STG_OPS_RISK_DATA.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_OPS_RISK_DATA.csv",
  },
  {
    name: "STG_OTHER_ASSET.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_OTHER_ASSET.csv",
  },
  {
    name: "STG_PARTY_FINANCIALS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_FINANCIALS.csv",
  },
  {
    name: "STG_PARTY_MASTER.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_MASTER.csv",
  },
  {
    name: "STG_PARTY_RATING_DETAILS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_RATING_DETAILS.csv",
  },
  {
    name: "STG_STAND_ALONE_CAPITAL.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_STAND_ALONE_CAPITAL.csv",
  },
  {
    name: "STG_SWAP_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_SWAP_CONTRACTS.csv",
  },
];

const HARD_VALIDATION_FILE_INPUTS = [
  {
    name: "STG_ACCOUNT_MITIGANT_MAP.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_ACCOUNT_MITIGANT_MAP.csv",
  },
  {
    name: "STG_BANK_POSITIONS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_BANK_POSITIONS.csv",
  },
  {
    name: "STG_CARDS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_CARDS.csv",
  },
  {
    name: "STG_FOREX_EXPOSURES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_FOREX_EXPOSURES.csv",
  },
  {
    name: "STG_FUTURES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_FUTURES.csv",
  },
  {
    name: "STG_GUARANTEES.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_GUARANTEES.csv",
  },
  {
    name: "STG_INSTRUMENT_CONTRACT_MASTER.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_INSTRUMENT_CONTRACT_MASTER.csv",
  },
  {
    name: "STG_INVESTMENTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_INVESTMENTS.csv",
  },
  {
    name: "STG_LETTER_CREDIT.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_LETTER_CREDIT.csv",
  },
  {
    name: "STG_LOAN_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_LOAN_CONTRACTS.csv",
  },
  {
    name: "STG_MITIGANT.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_MITIGANT.csv",
  },
  {
    name: "STG_MM_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_MM_CONTRACTS.csv",
  },
  {
    name: "STG_OPS_RISK_DATA.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_OPS_RISK_DATA.csv",
  },
  {
    name: "STG_OTHER_ASSET.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_OTHER_ASSET.csv",
  },
  {
    name: "STG_PARTY_FINANCIALS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_FINANCIALS.csv",
  },
  {
    name: "STG_PARTY_MASTER.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_MASTER.csv",
  },
  {
    name: "STG_PARTY_RATING_DETAILS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_PARTY_RATING_DETAILS.csv",
  },
  {
    name: "STG_STAND_ALONE_CAPITAL.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_STAND_ALONE_CAPITAL.csv",
  },
  {
    name: "STG_SWAP_CONTRACTS.csv",
    relative_path: "/16-09-2025_CAR_hhhhhh/STG_SWAP_CONTRACTS.csv",
  },
];

const OUTPUT_FILE_NAMES = [
  "OUT_OR_CAPITAL.xlsx",
  "OUT_CR_TREASURY_B3.xlsx",
  "OUT_CR_TRADE_FINANCE_B3.xlsx",
  "OUT_CR_CARD_B3.xlsx",
  "OUT_CR_MONEY_MARKET_B3.xlsx",
  "OUT_CR_LOAN_B3.xlsx",
  "OUT_CR_TREASURY_IRB.xlsx",
  "OUT_CR_TRADE_FINANCE_IRB.xlsx",
  "OUT_CR_MONEY_MARKET_IRB.xlsx",
  "OUT_CR_LOAN_IRB.xlsx",
  "OUT_CR_CARD_IRB.xlsx",
  "OUT_CR_LOAN_SA.xlsx",
  "OUT_CR_CARD_SA.xlsx",
  "OUT_CR_TRADE_FINANCE_SA.xlsx",
  "OUT_CR_TREASURY_SA.xlsx",
  "OUT_CR_MONEY_MARKET_SA.xlsx",
  "OUT_MR_IRR_GRM.xlsx",
  "OUT_MR_IRR_GRM_SUM.xlsx",
  "OUT_MR_IRR_SRW.xlsx",
  "OUT_CCR_K.xlsx",
  "OUT_MR_FX.xlsx",
  "OUT_CR_COMMITMENTS_B3.xlsx",
  "OUT_CR_COMMITMENTS_SA.xlsx",
];

const HARD_VALIDATION_REPORTS = [
  {
    report_name: "STG_PARTY_MASTER_VALIDATION.xlsx",
    isMissingData: true,
    isInvalidFormats: true,
    isParameter: true,
  },
  {
    report_name: "STG_LOAN_CONTRACTS_VALIDATION.xlsx",
    isMissingData: true,
    isInvalidFormats: true,
  },
  {
    report_name: "GL_RECONCILE.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isDoughtful: true,
  },
  {
    report_name: "STG_SWAP_CONTRACTS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_STAND_ALONE_CAPITAL_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_PARTY_RATING_DETAILS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_OTHER_ASSET_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_OPS_RISK_DATA_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_MM_CONTRACTS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_MITIGANT_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_LETTER_CREDIT_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_INVESTMENTS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_INSTRUMENT_CONTRACT_MASTER_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_PARTY_FINANCIALS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_GUARANTEES_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_FUTURES_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_FOREX_EXPOSURES_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_CARDS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_BANK_POSITIONS_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
  {
    report_name: "STG_ACCOUNT_MITIGANT_MAP_VALIDATION.xlsx",
    isMissingData: false,
    isInvalidFormats: false,
    isSuccess: true,
    noDownload: true,
  },
];

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    // const lstInputFiles = HARD_FILE_INPUTS || [];
    const lstInputFiles =
      fileInfo &&
      fileInfo.file_name &&
      fileInfo.file_name.toLowerCase().startsWith("car_validation")
        ? HARD_VALIDATION_FILE_INPUTS
        : HARD_FILE_INPUTS;

    this.state = {
      lstInput: lstInputFiles.map((e) => ({
        input: e.name,
        upload_by: fileInfo.upload_by,
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
        select: false,
      })),
      lstOutput: [],
      failedDownloadsList: [],
      isShowUpdateNameAndReportDateModal: false,
      isSelectAllInput: false,
      isSelectAllOutput: false,
      isSelectAllValidation: false,
      fileInfo: fileInfo,
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED &&
        fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      lstValidate: [],
      isValidated: false,
      isValidating: false,
      validateTime: Business.convertToFullDate(new Date()),
      isValidateSuccess: false,
      openCalculateModal: false,
      isApporvaling: false,
      isCalculating: false,
    };
  }

  listReportWillDelete = null;

  componentDidMount() {
    if (this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED) {
      this.getReportList();
    }
  }

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.CAR,
      this.state.fileInfo.file_name
    ).then((data) => {
      const lstOutput = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          if (!Business.isOutputFile(item.report_name)) return;
          item.created = Business.convertToFullDate(item.created);
          lstOutput.push(item);
        });
      }

      this.setState({
        lstOutput: lstOutput,
        loading: false,
      });
    });
  };

  onReject = () => {
    this.setState({ showRejectAlert: true });
  };

  onConfirmReject = () => {
    // Http.updateUploadInfo(
    //   Business.COMPONENT.CAR,
    //   this.state.reportDate,
    //   this.state.reportName,
    //   Business.ENUMS.FILE_STATUS.REJECTED,
    //   this.state.reason
    // ).then((res) => {
    //   if (!res) {
    //     Business.showAlert({ title: "Error", content: "Unknow Error" });
    //   } else {
    //     if (res.Success) {
    //       Business.showAlert({ title: "Info", content: "Successfully" });
    //       this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
    //       this.setState({
    //         status: Business.convertFileStatus(
    //           Business.ENUMS.FILE_STATUS.REJECTED
    //         ),
    //       });
    //     } else {
    //       switch (res.ErrorCode) {
    //         case ErrorCode.PermissionDenie:
    //           Business.showAlert({
    //             title: "Error",
    //             content: "You are not permission",
    //           });
    //         default:
    //           Business.showAlert({ title: "Error", content: "Unknow Error" });
    //       }
    //     }
    //   }
    // });
    setTimeout(() => {
      this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
      this.setState({
        status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.REJECTED),
      });
      Business.showAlert({ title: "Info", content: "Successfully" });
    }, 1000 * 10);
    this.setState({ showRejectAlert: false });
  };

  onApproval = () => {
    // Http.updateUploadInfo(
    //   Business.COMPONENT.CAR,
    //   this.state.reportDate,
    //   this.state.reportName,
    //   Business.ENUMS.FILE_STATUS.APPROVED,
    //   null
    // ).then((res) => {
    //   if (!res) {
    //     Business.showAlert({ title: "Error", content: "Unknow Error" });
    //   } else {
    //     if (res.Success) {
    //       Business.showAlert({ title: "Info", content: "Successfully" });
    //       this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
    //       this.setState({
    //         status: Business.convertFileStatus(
    //           Business.ENUMS.FILE_STATUS.APPROVED
    //         ),
    //       });
    //     } else {
    //       switch (res.ErrorCode) {
    //         case ErrorCode.PermissionDenie:
    //           Business.showAlert({
    //             title: "Error",
    //             content: "You are not permission",
    //           });
    //         default:
    //           Business.showAlert({ title: "Error", content: "Unknow Error" });
    //       }
    //     }
    //   }
    // });
    // this.setState({ showRejectAlert: false });
    this.setState({
      isDisableCalculateButton: true,
      isDisableApprovalButton: true,
    });
    setTimeout(() => {
      this.setState({
        isDisableCalculateButton: false,
        isDisableApprovalButton: false,
        status: Business.convertFileStatus(Business.ENUMS.FILE_STATUS.APPROVED),
      });
      Business.showAlert({ title: "Info", content: "Successfully" });
    }, 1000 * 10);
  };

  handleCalculate = () => {
    this.setState({
      isDisableCalculateButton: true,
      isDisableApprovalButton: true,
    });
    setTimeout(() => {
      const outputList = OUTPUT_FILE_NAMES.map((item) => ({
        report_name: item,
        created: Business.convertToFullDate(new Date()),
      }));
      // Save calculated report info to localStorage
      const now = new Date();
      const calculatedReport = {
        report_date: this.state.fileInfo.report_date,
        file_name: this.state.fileInfo.file_name,
        path: "",
        approval_by: this.state.fileInfo.approval_by || "administrator",
        approval_time: this.state.fileInfo.approval_time || now.toISOString(),
        upload_by: this.state.fileInfo.upload_by || "administrator",
        upload_time: this.state.fileInfo.upload_time || now.toISOString(),
        relative_path: "",
        timestamp: new Date(this.state.fileInfo.upload_time || now).getTime(),
      };
      let calculatedReports = [];
      try {
        calculatedReports =
          JSON.parse(localStorage.getItem("calculated_reports")) || [];
      } catch (e) {
        console.error(
          "Failed to parse calculated_reports from localStorage",
          e
        );
      }
      // Always append new calculatedReport to the top
      calculatedReports.unshift(calculatedReport);
      localStorage.setItem(
        "calculated_reports",
        JSON.stringify(calculatedReports)
      );
      this.setState({
        openCalculateModal: false,
        isDisableCalculateButton: false,
        isDisableApprovalButton: false,
        status: Business.convertFileStatus(
          Business.ENUMS.FILE_STATUS.CALCULATED
        ),
        lstOutput: outputList,
      });
      Business.showAlert({ title: "Info", content: "Successfully" });
    }, 1000 * 10);
  };

  onCalculate = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: "Error",
        content: "The system is busy. Please try again in a few moments.",
      });
      return;
    }

    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({
      loading: true,
      errorCode: ErrorCode.PendingBatchProcessing,
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATING
      ),
      openCalculateModal: false,
    });
    Http.calculate(this.state.reportDate, this.state.reportName, false).then(
      (res) => {
        this.setState({ loading: false });
        if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
          this.onGetBatchResponse();
        } else {
          this.handleCalculateResponse(res);
        }
      }
    );
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstInput.map((item) => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.forEach((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.forEach((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstOutput.forEach((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectValidation = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllValidation === true) {
        this.setState({ isSelectAllValidation: false });
        this.state.lstValidate.forEach((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllValidation: true });
        this.state.lstValidate.forEach((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstValidate.forEach((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onDownloadInputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          lstFileSelected.push(item.input);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        "input_calculation",
        Business.COMPONENT.CAR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        }
      );
    }
  };

  onDownloadOutputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      // this.setState({ loading: true });
      // await handleBatchDownload(
      //   this.state.fileInfo,
      //   lstFileSelected,
      //   this.state.reportDate,
      //   this.state.reportName,
      //   null,
      //   Business.COMPONENT.CAR,
      //   (message) => {
      //     if (message) {
      //       this.setState({ downloadProgressMessage: message });
      //     } else {
      //       this.setState({ downloadProgressMessage: "", loading: false });
      //     }
      //   }
      // );
      lstFileSelected.forEach((item) => {
        this.handleDownload(item, "car_output");
      });
    }
  };

  onDownloadAllOutputFIles = () => {
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      this.state.lstOutput.forEach((item) => {
        this.handleDownload(item.report_name, "car_output");
      });
    }
  };

  onDownloadAllValidationFIles = () => {
    if (this.state.lstValidate && this.state.lstValidate.length > 0) {
      this.state.lstValidate.forEach((item, id) => {
        if (item.noDownload) return;
        this.handleDownload(item.report_name, "car_validation");
      });
    }
  };

  onDownloadValidateFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstValidate && this.state.lstValidate.length > 0) {
      for (let i = 0; i < this.state.lstValidate.length; i++) {
        const item = this.state.lstValidate[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });

      lstFileSelected.forEach((item) => {
        if (item.noDownload) return;
        this.handleDownload(item, "car_validation");
      });
      this.setState({ loading: false });
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName).then(
        (res) => {
          this.handleGetBatchUploadingResponse(res);
        }
      );
    }, 3000);
    lstIntervalId.push(intervalId);
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
      ),
    });
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        singleResult: data.SingleResult,
        consolResult: data.ConsolResult,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn("Received state: BatchEmpty");
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              singleResult: data.SingleResult,
              consolResult: data.ConsolResult,
              status: Business.convertFileStatus(
                Business.ENUMS.FILE_STATUS.CALCULATED
              ),
            });
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  handleDownload = (fileName, folderName) => {
    const link = document.createElement("a");
    link.href = `/${folderName}/${fileName}`;
    link.download = fileName; // file name to save
    link.click();
  };

  handleValidate = () => {
    this.setState({ isValidating: true });
    const isSuccess =
      this.state.fileInfo.file_name &&
      !this.state.fileInfo.file_name.toLowerCase().startsWith("car_validation");
    const validatedOutputList = this.state.lstInput.map((item) => {
      return {
        ...item,
        isSuccess,
        isOther: false,
        isMissingData: false,
        isInvalidFormat: false,
        report_name: item.input,
        created: item.upload_time,
        select: false,
      };
    });
    const timeoutId = setTimeout(() => {
      this.setState({
        lstValidate: isSuccess
          ? [
              ...validatedOutputList,
              {
                report_name: "GL_RECONCILE.xlsx",
                name: "GL_RECONCILE.xlsx",
                isSuccess: false,
                isOther: false,
                isDoughtful: true,
                isMissingData: false,
                isInvalidFormats: false,
              },
            ]
          : HARD_VALIDATION_REPORTS,
        validateTime: Business.convertToFullDate(new Date()),
        isValidating: false,
        isValidated: true,
        isValidateSuccess: isSuccess,
      });
      clearTimeout(timeoutId); // clear ngay sau khi chạy xong
    }, 2000);
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
              paddingTop: "50px",
            }}
            className="title"
          >
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderInputFileManagement = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 8,
          }}
        >
          <p
            style={{
              marginBottom: 0,
              color: "#0B0B0A",
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            Input file
          </p>
          <div
            style={{
              display: "flex",
              marginBottom: "10px",
            }}
          >
            <button
              className={`btn btn-primary file-button validate-button ${
                this.state.isValidating ? "loading" : ""
              }`}
              onClick={this.handleValidate}
              disabled={this.state.isValidating}
            >
              <span className="validate-progress"></span>
              <span
                style={{
                  position: "relative",
                  zIndex: 2,
                }}
              >
                % Validate
              </span>
            </button>
            <a
              rel="tooltip"
              aria-disabled="true"
              className="btn btn-info btn-simple btn-xs"
              data-original-title="View Profile"
              onClick={() => {
                this.onDownloadInputFiles();
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "14px 12px",
              }}
            >
              <i
                style={{ fontSize: 16, color: "#1E1E1E" }}
                className="pe-7s-download"
              ></i>
              <span
                style={{
                  color: "#303030",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: 1,
                }}
              >
                Download selected files
              </span>
            </a>
          </div>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAllInput === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstInput.map((item, index) => (
                <tr key={item.input}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.input}`}
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.input}</td>
                  <td>{item.upload_by}</td>
                  <td>{item.upload_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderValidatedFileManagement = () => {
    return (
      <div
        style={{
          border: "1px solid #D9D9D9",
          borderRadius: 9,
          padding: 16,
          marginBottom: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 8,
          }}
        >
          <p
            style={{
              marginBottom: 0,
              color: "#0B0B0A",
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            {`Validation input file results (${this.state.validateTime})`}
          </p>
          {this.state.lstValidate.length > 0 && (
            <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
              <button
                className="btn btn-primary file-button validate-button"
                onClick={() => {
                  this.onDownloadAllValidationFIles();
                }}
              >
                <i
                  style={{ fontSize: 16, color: "#1E1E1E" }}
                  className="pe-7s-download"
                ></i>
                {this.state.fileInfo.file_name &&
                this.state.fileInfo.file_name
                  .toLowerCase()
                  .startsWith("car_validation")
                  ? `Download Error Files`
                  : `Download All`}
              </button>
              <a
                rel="tooltip"
                aria-disabled="true"
                className="btn btn-info btn-simple btn-xs"
                data-original-title="View Profile"
                onClick={() => {
                  this.onDownloadValidateFiles();
                }}
              >
                <i
                  style={{ fontSize: 16, color: "#1E1E1E" }}
                  className="pe-7s-download"
                ></i>
                <span
                  style={{
                    color: "#303030",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: 1,
                  }}
                >
                  Download selected files
                </span>
              </a>
            </div>
          )}
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectValidation("SELECT_ALL")}
                      checked={this.state.isSelectAllValidation === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Status</th>
                <th>Missing data</th>
                <th>Invalid format</th>
                <th>Parameter Reconcile</th>
                <th>Others</th>
              </tr>
            </thead>

            <tbody>
              {this.state.lstValidate.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() =>
                          this.onSelectValidation(item.report_name)
                        }
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>
                    <div
                      style={{
                        backgroundColor: item.isSuccess ? "#EFF8FF" : "#FFF6ED",
                        color: item.isSuccess ? "#175CD3" : "#C4320A",
                        border: `1px solid ${
                          item.isSuccess ? "#B2DDFF" : "#FDDCAB"
                        }`,
                        padding: "2px 8px",
                        fontSize: 12,
                        lineHeight: "18px",
                        fontWeight: 500,
                        borderRadius: 16,
                        textAlign: "center",
                      }}
                    >
                      {item.isSuccess
                        ? "Success"
                        : item.isDoughtful
                        ? "Doubtful"
                        : "Failed"}
                    </div>
                  </td>
                  <td>{item.isMissingData ? "x" : ""}</td>
                  <td>{item.isInvalidFormats ? "x" : ""}</td>
                  <td>{item.isParameter ? "x" : ""}</td>
                  <td>
                    {item.isOther ? (
                      <i
                        className="pe-7s-check"
                        style={{ fontSize: 16, marginRight: 8 }}
                      ></i>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderOutputFileManagement = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 8,
          }}
        >
          <p
            style={{
              marginBottom: 0,
              color: "#0B0B0A",
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            Output file
          </p>
          {this.state.lstOutput.length > 0 && (
            <a
              rel="tooltip"
              aria-disabled="true"
              className="btn btn-info btn-simple btn-xs"
              data-original-title="View Profile"
              onClick={() => {
                this.onDownloadOutputFiles();
              }}
            >
              <i
                style={{ fontSize: 16, color: "#1E1E1E" }}
                className="pe-7s-download"
              ></i>
              <span
                style={{
                  color: "#303030",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: 1,
                }}
              >
                Download selected files
              </span>
            </a>
          )}
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectOutput("SELECT_ALL")}
                      checked={this.state.isSelectAllOutput === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>

            <tbody>
              {this.state.lstOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() => this.onSelectOutput(item.report_name)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
              {this.state.lstOutput.length === 0 && (
                <tr style={{ borderBottom: "none" }}>
                  <td colSpan="4">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        height: 200,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          lineHeight: 1.2,
                          color: "#B3B3B3",
                          textAlign: "center",
                          marginBottom: 0,
                        }}
                      >
                        No documents found
                      </p>
                      <p
                        style={{
                          fontSize: 14,
                          lineHeight: 1.4,
                          color: "#B3B3B3",
                          textAlign: "center",
                          marginBottom: 0,
                        }}
                      >
                        Please calculate input files to see results.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Append CAR Calculation Table with SA Consol column */}
        <div
          style={{
            marginTop: 32,
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 1px 4px #0001",
            padding: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: 16 }}>
                CAR Calculation
              </div>
              <div style={{ fontSize: 12, color: "#888" }}>
                Unit: Million VND, %
              </div>
            </div>
            <button
              className="btn btn-link"
              style={{ fontSize: 14, textDecoration: "none" }}
            >
              <i
                className="pe-7s-download"
                style={{ fontSize: 18, marginRight: 4 }}
              ></i>
              Download selected file
            </button>
          </div>
          <table
            className="table table-bordered"
            style={{ background: "#fff", marginBottom: 0 }}
          >
            <thead>
              <tr>
                <th
                  rowSpan={3}
                  style={{ verticalAlign: "middle", textAlign: "center" }}
                >
                  #
                </th>
                <th
                  rowSpan={3}
                  style={{ verticalAlign: "middle", textAlign: "center" }}
                >
                  Category/Loại
                </th>
                <th colSpan={4} style={{ textAlign: "center" }}>
                  Thông tư 14
                </th>
                <th colSpan={2} style={{ textAlign: "center" }}>
                  Basel III
                </th>
              </tr>
              <tr>
                <th colSpan={2} style={{ textAlign: "center" }}>
                  SA
                </th>
                <th colSpan={2} style={{ textAlign: "center" }}>
                  IRB
                </th>
                <th colSpan={2} style={{ textAlign: "center" }}>
                  SA
                </th>
              </tr>
              <tr>
                <th style={{ textAlign: "center" }}>Single/Riêng lẻ</th>
                <th style={{ textAlign: "center" }}>Consol/Hợp nhất</th>
                <th style={{ textAlign: "center" }}>Single/Riêng lẻ</th>
                <th style={{ textAlign: "center" }}>Consol/Hợp nhất</th>
                <th style={{ textAlign: "center" }}>Single/Riêng lẻ</th>
                <th style={{ textAlign: "center" }}>Consol/Hợp nhất</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>CAR/ Tỷ lệ an toàn vốn</td>
                <td style={{ textAlign: "right" }}>17.05%</td>
                <td style={{ textAlign: "right" }}>16.58%</td>
                <td style={{ textAlign: "right" }}>19.89%</td>
                <td style={{ textAlign: "right" }}>19.36%</td>
                <td style={{ textAlign: "right" }}>14.55%</td>
                <td style={{ textAlign: "right" }}>14.26%</td>
              </tr>
              <tr>
                <td>2</td>
                <td>CET 1/ Tỷ lệ an toàn vốn cổ phần cấp 1</td>
                <td style={{ textAlign: "right" }}>10.92%</td>
                <td style={{ textAlign: "right" }}>10.81%</td>
                <td style={{ textAlign: "right" }}>12.73%</td>
                <td style={{ textAlign: "right" }}>12.63%</td>
                <td style={{ textAlign: "right" }}>9.33%</td>
                <td style={{ textAlign: "right" }}>9.31%</td>
              </tr>
              <tr>
                <td>3</td>
                <td>TIER 1/ Tỷ lệ an toàn vốn cấp 1</td>
                <td style={{ textAlign: "right" }}>10.92%</td>
                <td style={{ textAlign: "right" }}>10.81%</td>
                <td style={{ textAlign: "right" }}>12.73%</td>
                <td style={{ textAlign: "right" }}>12.63%</td>
                <td style={{ textAlign: "right" }}>9.33%</td>
                <td style={{ textAlign: "right" }}>9.31%</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Total Capital/ Tổng vốn tự có</td>
                <td style={{ textAlign: "right" }}>88,045</td>
                <td style={{ textAlign: "right" }}>95,102</td>
                <td style={{ textAlign: "right" }}>88,405</td>
                <td style={{ textAlign: "right" }}>95,102</td>
                <td style={{ textAlign: "right" }}>88,200</td>
                <td style={{ textAlign: "right" }}>95,257</td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  Common Equity Tier 1 Capital/ Vốn cổ phần phổ thông cấp 1
                </td>
                <td style={{ textAlign: "right" }}>56,382</td>
                <td style={{ textAlign: "right" }}>62,036</td>
                <td style={{ textAlign: "right" }}>56,382</td>
                <td style={{ textAlign: "right" }}>62,036</td>
                <td style={{ textAlign: "right" }}>56,537</td>
                <td style={{ textAlign: "right" }}>62,191</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Tier 1 Capital/ Vốn cấp 1</td>
                <td style={{ textAlign: "right" }}>56,382</td>
                <td style={{ textAlign: "right" }}>62,036</td>
                <td style={{ textAlign: "right" }}>56,382</td>
                <td style={{ textAlign: "right" }}>62,036</td>
                <td style={{ textAlign: "right" }}>56,537</td>
                <td style={{ textAlign: "right" }}>62,191</td>
              </tr>
              <tr>
                <td>7</td>
                <td>
                  Capital conservation buffer - CCB/ Tỷ lệ bộ đệm bảo toàn vốn
                </td>
                <td style={{ textAlign: "right" }}>2.50%</td>
                <td style={{ textAlign: "right" }}>2.50%</td>
                <td style={{ textAlign: "right" }}>2.50%</td>
                <td style={{ textAlign: "right" }}>2.50%</td>
                <td style={{ textAlign: "right" }}>2.50%</td>
                <td style={{ textAlign: "right" }}>2.50%</td>
              </tr>
              <tr>
                <td>8</td>
                <td>
                  Countercyclical capital buffer - CCyB/ Tỷ lệ bộ đệm vốn phản
                  chu kỳ
                </td>
                <td style={{ textAlign: "right" }}>0.50%</td>
                <td style={{ textAlign: "right" }}>0.50%</td>
                <td style={{ textAlign: "right" }}>0.50%</td>
                <td style={{ textAlign: "right" }}>0.50%</td>
                <td style={{ textAlign: "right" }}>0.50%</td>
                <td style={{ textAlign: "right" }}>0.50%</td>
              </tr>
              <tr>
                <td>9</td>
                <td>RWAcr/ Tổng tài sản có rủi ro tín dụng khách hàng</td>
                <td style={{ textAlign: "right" }}>469,448</td>
                <td style={{ textAlign: "right" }}>525,890</td>
                <td style={{ textAlign: "right" }}>395,789</td>
                <td style={{ textAlign: "right" }}>443,375</td>
                <td style={{ textAlign: "right" }}>502,674.09</td>
                <td style={{ textAlign: "right" }}>563,111.43</td>
              </tr>
              <tr>
                <td>10</td>
                <td>RWAccr/ Tổng tài sản có rủi ro tín dụng đối tác</td>
                <td style={{ textAlign: "right" }}>641</td>
                <td style={{ textAlign: "right" }}>649</td>
                <td style={{ textAlign: "right" }}>641</td>
                <td style={{ textAlign: "right" }}>649</td>
                <td style={{ textAlign: "right" }}>674</td>
                <td style={{ textAlign: "right" }}>683</td>
              </tr>
              <tr>
                <td>11</td>
                <td>RWAor/ Tổng tài sản có rủi ro hoạt động</td>
                <td style={{ textAlign: "right" }}>20,667</td>
                <td style={{ textAlign: "right" }}>21,287</td>
                <td style={{ textAlign: "right" }}>20,667</td>
                <td style={{ textAlign: "right" }}>21,287</td>
                <td style={{ textAlign: "right" }}>20,667</td>
                <td style={{ textAlign: "right" }}>21,287</td>
              </tr>
              <tr>
                <td>12</td>
                <td>RWAmr/ Tổng tài sản có rủi ro thị trường</td>
                <td style={{ textAlign: "right" }}>25,638</td>
                <td style={{ textAlign: "right" }}>25,825</td>
                <td style={{ textAlign: "right" }}>25,638</td>
                <td style={{ textAlign: "right" }}>25,825</td>
                <td style={{ textAlign: "right" }}>82,250</td>
                <td style={{ textAlign: "right" }}>82,913</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Coveragre ratio - Corporate/ Tỷ lệ bao phủ - KHDN</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>82.00%</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Coveragre ratio - Retail/ Tỷ lệ bao phủ - KHCN</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>71.30%</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
              </tr>
              <tr>
                <td>15</td>
                <td>
                  Coveragre ratio - Receivables/ Tỷ lệ bao phủ - Các khoản phải
                  thu
                </td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>12.00%</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Output Floor/ Tỷ lệ sàn đầu ra</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>85.74%</td>
                <td style={{ textAlign: "right" }}>85.62%</td>
                <td style={{ textAlign: "right" }}>N/A</td>
                <td style={{ textAlign: "right" }}>N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  onShowUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: true,
    });
  };

  onCloseUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  onCloseUpdateNameAndReportDateModalAndGetNewData = (
    reportDate,
    reportName
  ) => {
    const objSearch = {
      report_date: reportDate,
      file_name: reportName,
    };

    Http.getUploadManagement(Business.COMPONENT.CAR, objSearch).then((data) => {
      if (data && data.Success) {
        if (data.Data && data.Data.length === 1) {
          const fileInfo = data.Data[0];
          Business.showAlert({
            title: "Info",
            content: "Update successfully",
          });
          this.setState({
            fileInfo: fileInfo,
            reportDate: Business.convertToDate(fileInfo.report_date),
            reportName: fileInfo.file_name || "",
          });
        }
      }
    });

    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  renderUpdateNameAndReportDateModal = () => {
    return (
      <UpdateNameAndReportDateModalModal
        component={"CAR"}
        reportDate={this.state.reportDate}
        reportName={this.state.reportName}
        isShowUpdateNameAndReportDateModal={
          this.state.isShowUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModal={
          this.onCloseUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModalAndGetNewData={
          this.onCloseUpdateNameAndReportDateModalAndGetNewData
        }
      />
    );
  };

  renderBtnUpdateNameAndReportDate = () => {
    return (
      <i
        style={{
          fontSize: 23,
          color: "red",
          cursor: "pointer !important",
          marginBottom: 10,
        }}
        className="pe-7s-note"
        onClick={() => {
          this.setState({ isShowUpdateNameAndReportDateModal: true });
        }}
      ></i>
    );
  };

  renderResult = () => {
    const singleResult = this.state.singleResult || {};
    const consolResult = this.state.consolResult || {};
    return (
      <div>
        <div style={{ height: "100px" }} />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Category</th>
              <th>Single</th>
              <th>Consol</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td style={{ fontWeight: "bolder" }}>CAR</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.CAR || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.CAR || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>CET 1</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.CET1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.CET1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>TIER 1</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.TIER_1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.TIER_1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>Total Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.TOTAL_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.TOTAL_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Common Equity Tier 1 Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(
                  singleResult.COMMON_EQUITY_TIER_1_CAPITAL || 0
                ).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(
                  consolResult.COMMON_EQUITY_TIER_1_CAPITAL || 0
                ).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>Tier 1 Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.TIER_1_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.TIER_1_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>RWAce</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.RWA_CR || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.RWA_CR || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>RWAccr</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.RWA_CCR || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.RWA_CCR || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>MRC</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.MRC || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.MRC || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>ORC</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.ORC || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.ORC || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>CVA</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.CVA || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.CVA || 0).toLocaleString("en-GB")}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  render() {
    if (this.state.loading || this.state.downloadProgressMessage)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" message={this.state.downloadProgressMessage} />
        </div>
      );

    return (
      <div className="card">
        <div
          className="header"
          style={{ display: "flex", flexDirection: "column", gap: 16 }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              color: "#757575",
              fontSize: 16,
            }}
          >
            <p style={{ marginBottom: 0 }}>CAR</p>
            <p style={{ marginBottom: 0 }}>/</p>
            <p style={{ marginBottom: 0 }}>File Management</p>
            <p style={{ marginBottom: 0 }}>/</p>
            <p style={{ color: "#BF6A02", marginBottom: 0 }}>Report Detail</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              {this.state.fileInfo.status &&
                this.state.fileInfo.status !==
                  Business.ENUMS.FILE_STATUS.CALCULATED &&
                this.state.fileInfo.status !==
                  Business.ENUMS.FILE_STATUS.CALCULATING &&
                this.renderBtnUpdateNameAndReportDate()}
              <div
                className="title"
                style={{
                  display: "flex",
                  gap: 8,
                  color: "#0B0B0A",
                  fontSize: 16,
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontSize: 20,
                    fontWeight: 400,
                    marginBottom: 0,
                    lineHeight: 1.2,
                  }}
                >
                  {Business.convertReportName(
                    this.state.reportName || "",
                    "CAR"
                  )}
                </p>
                {this.state.status ? (
                  <div
                    style={{
                      height: 26,
                      backgroundColor: "#EEF4FF",
                      color: "#3538CD",
                      border: "1px solid #C7D7FE",
                      padding: "2px 8px",
                      lineHeight: 1.4,
                      fontWeight: 400,
                      borderRadius: 16,
                      textAlign: "center",
                    }}
                  >
                    {this.state.status}
                  </div>
                ) : null}
                <p style={{ marginBottom: 0, color: "#0B0B0A", fontSize: 16 }}>
                  /
                </p>
                <p
                  style={{ marginBottom: 0, color: "#0B0B0A", fontSize: 16 }}
                >{`${this.state.reportDate || ""}`}</p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16 }}>
              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableRejectButton
                }
                className="btn btn-primary file-button reject-button"
                onClick={() => {
                  this.onReject();
                }}
              >
                <i
                  className="pe-7s-close-circle"
                  style={{ fontSize: 16, color: "#FEE9E7" }}
                ></i>
                Reject
              </button>

              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableApprovalButton ||
                  !Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_APPROVAL_FILES,
                  ]) ||
                  !this.state.isValidated ||
                  !this.state.isValidateSuccess
                }
                className={`btn btn-primary file-button approve-button ${
                  this.state.isApporvaling ? "loading" : ""
                }`}
                style={{ marginLeft: 0 }}
                onClick={() => {
                  this.onApproval();
                }}
              >
                <i className="pe-7s-check"></i>
                Approval
              </button>

              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableCalculateButton ||
                  !Business.isHasRole([Business.ROLE_DEFINE_MAP.CAR_CALCULATE])
                }
                className="btn btn-primary file-button approve-button"
                onClick={() => {
                  this.handleCalculate();
                }}
              >
                <i className="pe-7s-check"></i>
                Calculate
              </button>
            </div>
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {this.renderUpdateNameAndReportDateModal()}

          {this.renderInputFileManagement()}
          {this.state.lstValidate.length > 0 &&
            this.renderValidatedFileManagement()}
          {/* Only show output file management if status is APPROVED or CALCULATED */}
          {this.state.status ===
            Business.convertFileStatus(Business.ENUMS.FILE_STATUS.CALCULATED) &&
            this.renderOutputFileManagement()}

          <div>
            <FormGroup controlId="formControlsTextarea">
              <label htmlFor="exampleInputEmail1">Reason for rejection: </label>
              <FormControl
                style={{ height: "100px", resize: "none" }}
                disabled={this.state.isDisableReasonInput}
                componentClass="textarea"
                value={this.state.reason}
                placeholder="Type your reason here..."
                onChange={(event) => {
                  this.setState({ reason: event.target.value });
                }}
              />
            </FormGroup>
            <div style={{ display: "inline" }}>
              <div style={{ display: "flex", float: "right" }}></div>
            </div>
          </div>

          {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
            this.renderPendingBatchProcessing()}
          {/* Only show result if status is CALCULATED */}
          {this.state.status ===
            Business.convertFileStatus(Business.ENUMS.FILE_STATUS.CALCULATED) &&
            this.state.hasResult &&
            this.renderResult()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => {
            this.onConfirmReject();
          }}
          onCancel={() => {
            this.setState({ showRejectAlert: false });
          }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(
            ", "
          )}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
        <Modal show={this.state.openCalculateModal} size="md" centered>
          <ModalHeader
            style={{
              fontSize: 24,
              color: "#1E1E1E",
            }}
          >
            Calculate
          </ModalHeader>
          <ModalBody>
            <span>Tỉ lệ bộ đệm vốn phản đang được NHNN quy định *</span>
            <input
              type="text"
              placeholder="Eg: 0.50"
              style={{
                width: "100%",
                marginTop: 8,
                marginBottom: 16,
                padding: 8,
                fontSize: 16,
              }}
            />
            <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
              <button
                className="btn"
                onClick={() => {
                  this.setState({ openCalculateModal: false });
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableCalculateButton ||
                  !Business.isHasRole([Business.ROLE_DEFINE_MAP.CAR_CALCULATE])
                }
                className="btn btn-primary file-button approve-button"
                style={{ marginLeft: 0 }}
                onClick={() => {
                  this.handleCalculate();
                }}
              >
                <i className="pe-7s-check"></i>
                Calculate
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

let lstIntervalDownload = [];
function clearGetBatchDownloadInterval() {
  lstIntervalDownload.forEach((id) => {
    clearInterval(id);
    console.warn(`${id} | Received state: STOP`);
  });
}

async function handleBatchDownload(
  fileInfo,
  lstFileSelected,
  reportDate,
  reportName,
  type,
  component,
  cb
) {
  const res = await Http.createDownloadId(
    `${uuidv4()}`,
    lstFileSelected,
    reportDate,
    reportName,
    type,
    component
  );
  if (res && res.Success && res.Data) {
    const downloadId = res.Data.download_id;
    const intervalId = setInterval(() => {
      console.warn(`${downloadId} | Request to get batch download`);
      Http.getBatchDownload(downloadId).then((res) => {
        if (res) {
          if (res.ErrorCode === ErrorCode.PendingDownload) {
            console.warn(`${downloadId} | Received state: PendingDownload`);
            if (res.Data.progress && res.Data.eta) {
              const message = `Progress: ${res.Data.progress.toFixed(
                2
              )}% - EstimatedTime: ${Business.formatSecondsToMinutes(
                res.Data.eta
              )}`;
              cb && cb(message);
            }
          } else if (res.ErrorCode === ErrorCode.DownloadCompleted) {
            Http.downloadFileByDownloadId(
              downloadId,
              fileInfo.report_date,
              fileInfo.file_name
            );
            clearGetBatchDownloadInterval();
            cb && cb();
            console.warn(`${downloadId} | Received state: Success`);
          } else {
            clearGetBatchDownloadInterval();
            cb && cb();
            console.warn(`${downloadId} | Received state: DownloadFailed`);
          }
        }
      });
    }, 3000);
    lstIntervalDownload.push(intervalId);
  }
}

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach((intervalId) => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

export default FileInfo;



// WEBPACK FOOTER //
// ./src/pages/CAR/FileManagement/FileInfo.js